import { useState, useEffect, useRef, } from 'react';
import oneHatData from '@onehat/data';
import withComponent from '@onehat/ui/src/Components/Hoc/withComponent.js';
import getSaved from '@onehat/ui/src/Functions/getSaved.js';
import setSaved from '@onehat/ui/src/Functions/setSaved.js';
import TabBar from '@onehat/ui/src/Components/Tab/TabBar.js';
import Plus from '@onehat/ui/src/Components/Icons/Plus.js';
import AddConnection from './AddConnection.js';
import ChatMessagesScreen from './ChatMessages.js';
import AppGlobals from '../../AppGlobals.js';
import _ from 'lodash';

function ChatRecipients(props) {
	const {
			self,
		} = props,
		tabs = useRef([{
			title: 'New Connection',
			_icon: { as: 'Plus' },
			disableCloseBox: true,
			isNewConnectionTab: true,
		}]),
		[currentTabIx, setCurrentTabIxRaw] = useState(0),
		[excludedUsernames, setExcludedUsernamesRaw] = useState([]),
		[isAddConnectionShown, setIsAddConnectionShownRaw] = useState(true),
		[isReady, setIsReady] = useState(false),
		ChatMessages = oneHatData.getRepository('ChatMessages'),
		setTabs = (newTabs) => {
			tabs.current = newTabs
			setSaved('ChatRecipients-tabs', newTabs);
		},
		getTabs = () => {
			return tabs.current;
		},
		setCurrentTabIx = async (ix) => {
			if (ix === 0) {
				setIsAddConnectionShown(true);
			}
			setCurrentTabIxRaw(ix);
			setSaved('ChatRecipients-currentTabIx', ix);

			if (ix === 0) {
				AppGlobals.chatManager.setCurrentRecipient(null);
			} else {
				const
					tab = getTabs()[ix],
					chatRecipient = tab.chatRecipient;

				AppGlobals.chatManager.setCurrentRecipient(chatRecipient);

				ChatMessages.setFilters({
					chat_messages__conversation_num: chatRecipient.chat_recipients__conversation_num,
				});
				await ChatMessages.load();
			}
		},
		setExcludedUsernames = (excludedUsernames) => {
			setExcludedUsernamesRaw(excludedUsernames);
			setSaved('ChatRecipients-excludedUsernames', excludedUsernames);
		},
		setIsAddConnectionShown = (isAddConnectionShown) => {
			setIsAddConnectionShownRaw(isAddConnectionShown);
			setSaved('ChatRecipients-isAddConnectionShown', isAddConnectionShown);
		},
		addExcludedUsername = (username) => {
			const usernames = _.clone(excludedUsernames);
			usernames.push(username);
			setExcludedUsernames(usernames);
		},
		removeExcludedUsername = (username) => {
			const usernames = _.filter(excludedUsernames, (excludedUsername) => excludedUsername !== username);
			setExcludedUsernames(usernames);
		},
		onTabClose = (ix) => {
			if (getTabs()[ix].isNewConnectionTab) {
				return;
			}
			const
				username = getTabs()[ix].chatRecipient.recipients__username,
				newTabs = _.filter(getTabs(), (tab, tabIx) => tabIx !== ix);
			setTabs(newTabs);

			removeExcludedUsername(username);

			// switch to nearest tab, if possible
			if (newTabs.length) {
				setCurrentTabIx(newTabs.length -1);
			} else {
				setIsAddConnectionShown(true);
			}
		},
		onChangeCurrentTab = (ix) => {
			setCurrentTabIx(ix);
			setIsAddConnectionShownRaw(ix === 0)
		},
		addTab = (chatRecipient) => {
			const newTabs = _.clone(getTabs());
			newTabs.push({
				_icon: { as: 'Comments' },
				title: chatRecipient.recipients__full_name,
				chatRecipient: chatRecipient.displayValues,
			});
			setTabs(newTabs);
			setCurrentTabIx(newTabs.length -1);
		},
		onAddConnection = (chatRecipient) => {
			const username = chatRecipient.recipients__username;
			addTab(chatRecipient);

			AppGlobals.chatManager.setCurrentRecipient(chatRecipient);

			addExcludedUsername(username);
			setIsAddConnectionShown(false);
		},
		renderCurrentTabContent = () => {
			if (isAddConnectionShown) {
				return <AddConnection
							excludedUsernames={excludedUsernames}
							onAddConnection={onAddConnection}
						/>;
			}
			if (_.isEmpty(getTabs())) {
				return null;
			}
			if (!getTabs()[currentTabIx]) {
				return null;
			}
			return <ChatMessagesScreen />;
		};

	useEffect(() => {
		(async () => {
			
			const tabs = await getSaved('ChatRecipients-tabs');
			if (!_.isNil(tabs)) {
				setTabs(tabs);
			}
			const excludedUsernames = await getSaved('ChatRecipients-excludedUsernames');
			if (!_.isNil(excludedUsernames)) {
				setExcludedUsernames(excludedUsernames);
			}
			const isAddConnectionShown = await getSaved('ChatRecipients-isAddConnectionShown');
			if (!_.isNil(isAddConnectionShown)) {
				setIsAddConnectionShown(isAddConnectionShown);
			}
			const currentTabIx = await getSaved('ChatRecipients-currentTabIx');
			if (!_.isNil(currentTabIx)) {
				setCurrentTabIx(currentTabIx);
			}

			if (!isReady) {
				setIsReady(true);
			}
		})();
	}, []);

	if (!isReady) {
		return null;
	}

	return <TabBar
				parent={self}
				tabs={getTabs()}
				currentTabIx={currentTabIx}
				content={renderCurrentTabContent()}
				onChangeCurrentTab={onChangeCurrentTab}
				onTabClose={onTabClose}
				disableCollapse={true}
				startsCollapsed={false}
			/>;
}

export default withComponent(ChatRecipients);